import { Link } from "react-router-dom";
import { Phone, Menu, X, Download } from "lucide-react";
import { useState, useEffect } from "react";

export default function Navbar({ onInstall }) {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { href: "#services", label: "Services" },
    { href: "#about", label: "About" },
    { href: "#reviews", label: "Reviews" },
    { href: "#service-area", label: "Service Area" },
    { href: "#payment", label: "Pay Invoice" },
    { href: "#contact", label: "Contact" },
  ];

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all ${
        scrolled
          ? "bg-[#0B1810]/95 backdrop-blur border-b border-[#2A332C]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-2">
          <div className="w-9 h-9 bg-[#FF5A00] flex items-center justify-center">
            <span className="font-heading text-xl text-white leading-none">HC</span>
          </div>
          <span className="font-heading text-2xl text-white tracking-wider">
            Hurricane Cuts
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase().replace(" ", "-")}`}
              className="font-accent text-xs tracking-[0.2em] uppercase text-white/80 hover:text-[#FF5A00] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          {onInstall && (
            <button
              data-testid="install-app-button"
              onClick={onInstall}
              className="btn-ghost-inverse !py-2 !px-4 !text-sm"
            >
              <Download size={16} /> Install App
            </button>
          )}
          <a
            data-testid="nav-phone-link"
            href="tel:+13216826085"
            className="btn-primary !py-2 !px-4 !text-sm"
          >
            <Phone size={16} /> (321) 682-6085
          </a>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="lg:hidden text-white"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-[#0B1810] border-t border-[#2A332C] px-6 py-6 space-y-5">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block font-heading text-2xl text-white hover:text-[#FF5A00]"
            >
              {l.label}
            </a>
          ))}
          <a
            href="tel:+13216826085"
            className="btn-primary w-full justify-center !text-base"
          >
            <Phone size={16} /> (321) 682-6085
          </a>
          {onInstall && (
            <button
              onClick={() => {
                onInstall();
                setOpen(false);
              }}
              className="btn-ghost-inverse w-full justify-center !text-base"
            >
              <Download size={16} /> Install App
            </button>
          )}
        </div>
      )}
    </header>
  );
}
